import React from "react";
import "./ToggleBtn.css";
import { FontIcon } from "@fluentui/react";

function toggleBtn(props: any) {
  return (
    <button
      className="toggler-btn"
      onClick={() => {
        props.openSidebar();
      }}
      type="button">
      <span className="material-symbols-outlined">menu</span>
    </button>
  );
}

export default toggleBtn;
